<script lang="ts">
  import { onMount } from 'svelte';
  import { t } from 'svelte-i18n';

  import { writable } from 'svelte/store';
  import { checkInitialHeaderColors } from '../shared/header-store';
  import Header from '../shared/header.svelte';
  import { modalComponent, modalKeys } from '../shared/modal-store';
  import transition from '../shared/transition.svelte';

  type Favicon = 'light' | 'dark';

  let favicon: Favicon = 'light';
  const matcher: MediaQueryList = window.matchMedia('(prefers-color-scheme: dark)');
  const width = writable();

  onMount(() => {
    checkModalSearchParam();
    checkInitialHeaderColors();
    setHeaderColorOnBack();
    setFaviconListener();
  });

  function setFaviconListener() {
    matcher.addListener(onMediaUpdate);
    onMediaUpdate();
  }

  function onMediaUpdate() {
    if (matcher && matcher.matches) {
      favicon = 'dark';
    } else {
      favicon = 'light';
    }
  }

  function setHeaderColorOnBack() {
    window.addEventListener('popstate', () => {
      setTimeout(() => {
        checkInitialHeaderColors();
      }, 0);
    });
  }

  function checkModalSearchParam() {
    const { hash } = window.location;

    if (!hash) {
      return;
    }

    const currentModal = modalKeys.find((item) => {
      return item.app === hash.replace(/[#]/, '');
    });

    modalComponent.set({ app: currentModal.app, component: currentModal.component });
  }
</script>

<svelte:head>
  <link href={`images/favicon-${favicon}.png`} rel="icon" type="image/png" />
  <link href={`images/favicon-${favicon}.svg`} rel="icon" type="image/svg+xml" />
  <title>{$t('TITLE')}</title>
</svelte:head>

<div
  id="container"
  class="transition-filter duration-[315ms] ease-linear selection:bg-blue-bg selection:text-white"
  bind:offsetWidth={$width}
  style="height: 100%;"
>
  <Header />

  <slot decorator={transition} scoped={{ width }} />
</div>
